import React, { useEffect, useState } from 'react';
import { GitCommit, Clock, CheckCircle, AlertCircle, Package } from 'lucide-react';
import { colors } from '../../constants/theme';

const VersionInfo: React.FC = () => {
  const [deployTime, setDeployTime] = useState<string>('');
  const [isOnline, setIsOnline] = useState(true);
  const [isExpanded, setIsExpanded] = useState(false);

  // バージョン情報（ビルド時に自動更新）
  const version = '2.0.0';
  const buildDate = new Date().toISOString().split('T')[0];
  const commitHash = '6b97015'; // 最新のコミットハッシュ

  useEffect(() => {
    // デプロイ時刻を取得
    const now = new Date();
    const timeString = now.toLocaleTimeString('ja-JP', { 
      hour: '2-digit', 
      minute: '2-digit' 
    });
    const dateString = now.toLocaleDateString('ja-JP', { 
      month: 'short', 
      day: 'numeric' 
    });
    setDeployTime(`${dateString} ${timeString}`);

    // オンライン状態の監視
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <div 
      className="fixed bottom-0 left-0 bg-white border-t border-r rounded-tr-lg shadow-sm z-50 cursor-pointer transition-all duration-200"
      style={{ 
        borderColor: colors.ui.border,
        width: isExpanded ? '280px' : '150px'
      }}
      onClick={() => setIsExpanded(!isExpanded)}
    >
      <div className="p-3">
        <div className="flex flex-col gap-1">
          {/* バージョン情報 */}
          <div className="flex items-center gap-2">
            <div className="flex items-center gap-1">
              <div className="w-2 h-2 rounded-full animate-pulse"
                style={{ backgroundColor: isOnline ? colors.support.success : colors.status.warning }}
              />
              <Package size={12} style={{ color: colors.text.secondary }} />
              <span className="text-xs font-mono font-semibold" style={{ color: colors.text.primary }}>
                v{version}
              </span>
            </div>
            {isExpanded && (
              <span className="text-xs" style={{ color: colors.text.secondary }}>
                {buildDate}
              </span>
            )}
          </div>

        {/* コミット情報 */}
        <div className="flex items-center gap-2">
          <GitCommit size={10} style={{ color: colors.text.secondary }} />
          <span className="text-xs font-mono" style={{ color: colors.text.secondary }}>
            {commitHash.substring(0, 7)}
          </span>
          <span className="text-xs" style={{ color: colors.text.secondary }}>
            •
          </span>
          <Clock size={10} style={{ color: colors.text.secondary }} />
          <span className="text-xs" style={{ color: colors.text.secondary }}>
            {deployTime}
          </span>
        </div>

        {/* 接続状態 */}
        <div className="flex items-center gap-1">
          {isOnline ? (
            <>
              <CheckCircle size={10} style={{ color: colors.support.success }} />
              <span className="text-xs" style={{ color: colors.support.success }}>
                オンライン
              </span>
            </>
          ) : (
            <>
              <AlertCircle size={10} style={{ color: colors.status.warning }} />
              <span className="text-xs" style={{ color: colors.status.warning }}>
                オフライン
              </span>
            </>
          )}
        </div>
        </div>
      </div>

      {/* ホバー時の詳細表示 */}
      <div className="absolute bottom-full left-0 mb-2 p-2 bg-gray-900 text-white text-xs rounded shadow-lg opacity-0 hover:opacity-100 transition-opacity pointer-events-none">
        <div className="whitespace-nowrap">
          <p>Retail Agent SPA</p>
          <p>Version: {version}</p>
          <p>Build: {buildDate}</p>
          <p>Commit: {commitHash}</p>
          <p>Status: {isOnline ? 'Connected' : 'Offline'}</p>
        </div>
      </div>
    </div>
  );
};

export default VersionInfo;
